import { render, staticRenderFns } from "./DialogConfirma.vue?vue&type=template&id=61fe3150&scoped=true&"
import script from "./DialogConfirma.vue?vue&type=script&lang=js&"
export * from "./DialogConfirma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fe3150",
  null
  
)

export default component.exports